import script from "./TokenNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenNumber.vue?vue&type=script&setup=true&lang=js"

import "./TokenNumber.vue?vue&type=style&index=0&id=505cdb1c&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505cdb1c"]])

export default __exports__